var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('input',_vm._b({attrs:{"type":"submit"}},'input',_vm.data,false))])}
var staticRenderFns = []

export { render, staticRenderFns }